import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import {
  Card, CardBody, CardHeader, CardTitle
} from "reactstrap";
import TableLoader from "components/Common/Loader";
import { fetchLeadAssign } from "store/teams/actions";
import {
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Table,
} from "react-super-responsive-table";
import CustomPagination from "components/Common/CustomPagination";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import EditLeadStructure from "./EditLeadStructure";
import FeatherIcon from "feather-icons-react";
import usePermissions from "routes/permissions";
import AddLeadStructure from "./AddLeadStructure";

function LeadAssign() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [sizePerPage, setSizePerPage] = useState(10);
  const [group, setGroup] = useState(null);

  const {
    clearingCounter
  } = useSelector((state)=>({
    clearingCounter: state.teamsReducer.clearingCounter || 0
  }));

  const {
    leadAssignPermissions,
  } = usePermissions();
  const {
    loading,
    docs,
    pagination,
  } = useSelector((state) => ({
    loading: state.teamsReducer.leadAssign?.loading || false,
    docs: state.teamsReducer.leadAssign?.docs || [],
    pagination: state.teamsReducer.leadAssign?.pagination || {},
  }));

  const columns = [
    {
      text: "Group Type",
      dataField: "type",
      sort: true,
    },
    {
      text: "(Campaign / Team) Name",
      dataField: "name",
      sort: true,
      formatter: (val) => (
        <>
          {
            val.type === "facebook-campaigns" ? `Campaign: ${val.typeId.campaignName}` : `Team: ${val?.typeId?.title}`
          }
        </>
      ),
    },
    {
      text: "Members",
      dataField: "members",
      sort: true,
      formatter: (team) => (
        <>
          {team.structure ? (
            <>
              {team.structure.length}
            </>
          ) : (
            "None"
          )}
        </>
      ),
    },
    {
      dataField: "",
      isDummyField: true,
      editable: false,
      text: "Action",
      formatter: (value) => (
        <div className="text-center cursor-pointer">
          <div className={`text-success ${!parseInt(1) ? "d-none" : ""}`} to="#">
            <i
              className="mdi mdi-pencil font-size-18"
              id="edittooltip"
              onClick={() => setGroup(value)}
            ></i>
          </div>
        </div>
      ),
    },
  ];

  const loadTeams = (page, limit) => {
    dispatch(fetchLeadAssign({
      page,
      limit,
    }));
  };
  
  useEffect(() => {
    loadTeams(1, sizePerPage);
  }, [clearingCounter]);

  return (
    <React.Fragment>
      <MetaTags>
        <title>{t("Lead Assign")}</title>
      </MetaTags>
      <div className="page-content">
        <div className="container-fluid">
          <h2>{t("Lead Assign")}</h2>
          <Card>
            <CardHeader className="d-flex justify-content-between  align-items-center">
              <CardTitle>
                Teams List ({pagination?.totalDocs || 0})
                <FeatherIcon
                  icon="refresh-cw"
                  className="icon-lg ms-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => { loadTeams(1, sizePerPage) }}
                />
              </CardTitle>
              { leadAssignPermissions.create && <>
                <div className="d-flex flex-row align-items-center justify-content-between">
                  <AddLeadStructure />
                </div>
              </>}
            </CardHeader>
            {
              leadAssignPermissions.update && group && (
                <EditLeadStructure t={t} toggle={() => setGroup(null)} typeId={group} />
              )
            }
            <CardBody>
              <div className="table-rep-plugin">
                <div
                  className="table-responsive mb-0"
                  data-pattern="priority-columns"
                >
                  <Table
                    id="tech-companies-1"
                    className="table  table-hover "
                  >
                    <Thead className="text-center table-light" >
                      <Tr>
                        {columns.map((column, index) =>
                          <Th data-priority={index} key={index}>{column.text}</Th>
                        )}
                      </Tr>
                    </Thead>
                    <Tbody className="text-center">
                      {loading && <TableLoader colSpan={6} />}
                      {!loading && docs.map((row, rowIndex) =>
                        <Tr key={rowIndex}>
                          {columns.map((column, index) =>
                            <Td key={`${rowIndex}-${index}`}>
                              {column.formatter ? column.formatter(row, rowIndex) : row[column.dataField]}
                            </Td>
                          )}
                        </Tr>
                      )}
                    </Tbody>
                  </Table>
                  <CustomPagination
                    docs={docs}
                    sizePerPage={sizePerPage}
                    setSizePerPage={setSizePerPage}
                    onChange={loadTeams}
                    {...pagination}
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </React.Fragment>
  );
}
export default LeadAssign;